/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import Header from "../Common/Navbar";
import { fetchApi } from "../utlis/axios";
import { useSelector } from "react-redux";
import Lottie from "lottie-react";
import Loader from "../animation/Loader.json";
import { toast } from "react-toastify";
import FingerPrintPage from "../Fingerprint/FingerPrintPage";
import "./style.css";
import { FaChevronLeft } from "react-icons/fa";
import DocumentCard from "./DocumentCard";
import { IoMdClose } from "react-icons/io";

export const MemberListingdetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(null);
  const [data, setData] = useState();
  const { access } = useSelector((state) => state.authSlice.userInfo);
  const [isEditing, setIsEditing] = useState(false);
  const [step, setStep] = useState(1);
  const [type, setType] = useState("text");
  const [cnicFront, setCnicFront] = useState();
  const [cnicBack, setCnicBack] = useState();
  const [workExperience, setWorkExperience] = useState([]);
  const [educationalDoc, setEducationalDoc] = useState([]);
  const [familyData, setFamilyData] = useState();
  const [editedData, setEditedData] = useState({});
  const [familyid, setFamilyId] = useState();
  const [loading, setLoading] = useState(false);
  const [disablefield, setDisableField] = useState(false);
  const [fingerprintpage, setFringerprintpage] = useState(true);

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const result = await fetchApi.get(`member/${id}/`, {
        headers: {
          Authorization: `Bearer ${access}`,
        },
      });
      if (result.status === 200) {
        setData(result?.data);
        console.log("member detail :", result?.data);
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      console.log({ error });
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleEditClick = (id) => {
    setIsEditing(true);
    setEditedData({ ...data });
    setFamilyId(id);
  };

  const handleNext = () => {
    setStep(step + 1);
  };

  const handleBack = () => {
    setStep(step - 1);
  };

  const getFamilydata = async () => {
    try {
      const result = await fetchApi.get(`family/${familyid}`, {
        headers: {
          Authorization: `Bearer ${access}`,
        },
      });
      if (result.status === 200) {
        setFamilyData(result.data);
        console.log("Family data...", result.data);
      } else {
        console.error("Failed to fetch data:", result.status);
      }
    } catch (error) {
      console.log({ error });
    }
  };

  useEffect(() => {
    getFamilydata();
  }, [familyid]);

  const handleUpdate = async () => {
    setIsLoading(true);
    try {
      const formData = new FormData();
      formData.append("id", id);
      formData.append("first_name", editedData?.first_name);
      formData.append("last_name", editedData?.last_name);
      formData.append("age", editedData?.age);
      formData.append("cnic_number", editedData?.cnic_number);
      formData.append("date_of_birth", editedData?.date_of_birth);
      formData.append(
        "education_or_qualification",
        editedData?.education_or_qualification
      );
      formData.append("education_status", editedData?.education_status);
      formData.append(
        "education_status_statement",
        editedData?.education_status_statement
      );
      formData.append("willing_to_study", editedData?.willing_to_study);
      formData.append("job", editedData?.job);
      formData.append("monthly_income", editedData?.monthly_income);
      formData.append("medical_condition", editedData?.medical_condition);
      formData.append("permanent_medication", editedData?.permanent_medication);
      formData.append(
        "permanent_medication_description",
        editedData?.permanent_medication_description
      );
      formData.append("gender", editedData?.gender);
      formData.append("skills", editedData?.skills);
      formData.append("num_of_childrens", editedData?.num_of_childrens);
      formData.append("marital_status", editedData?.marital_status);
      formData.append("family", familyid);
      formData.append("address", editedData?.address);
      formData.append("is_active", true);
      if (cnicFront) {
        formData.append("cnic_front", cnicFront);
      }

      if (cnicBack) {
        formData.append("cnic_back", cnicBack);
      }

      educationalDoc.forEach((docId) => {
        formData.append("education_documents", docId?.id);
      });

      workExperience.forEach((docId) => {
        formData.append("work_experience_documents", docId?.id);
      });

      const result = await fetchApi.patch(`member/${id}/`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${access}`,
        },
      });

      if (result.status === 200) {
        setData({ ...data, ...editedData });
        setIsEditing(false);
        setEditedData({});
        console.log("updated data", result?.data);
      }
      fetchData();
    } catch (error) {
      console.error(error);
      toast.error(error?.response?.data?.detail);
    } finally {
      setIsLoading(false);
    }
  };

  const handleWorkChange = async (e) => {
    const newFiles = e.target.files;

    if (newFiles.length > 0) {
      setLoading(true);
      const updatedSelectedFiles = [...workExperience];

      for (let i = 0; i < newFiles.length; i++) {
        const file = newFiles[i];
        const data = new FormData();
        data.append("file", file);
        data.append("type", "Experience Document");
        data.append("is_active", true);

        try {
          const result = await fetchApi.post("attachments/", data, {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${access}`,
            },
          });

          if (result?.status === 201) {
            updatedSelectedFiles.push({ id: result.data.id, name: file.name });
          }
        } catch (error) {
          console.error("Error uploading file:", error);
          setLoading(false);
          return;
        }
      }

      setWorkExperience(updatedSelectedFiles);
      setLoading(false);
    } else {
      console.log("Please select at least one file.");
    }
  };

  const handleworkFileDelete = (index) => {
    const updatedworkDoc = [...workExperience];
    updatedworkDoc.splice(index, 1);
    setWorkExperience(updatedworkDoc);
  };

  const handleEducationalChange = async (e) => {
    const newFiles = e.target.files;

    if (newFiles.length > 0) {
      setLoading(true);
      const updatedSelectedFiles = [...educationalDoc];

      for (let i = 0; i < newFiles.length; i++) {
        const file = newFiles[i];
        const data = new FormData();
        data.append("file", file);
        data.append("type", "Property Document");
        data.append("is_active", true);

        try {
          const result = await fetchApi.post("attachments/", data, {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${access}`,
            },
          });

          if (result?.status === 201) {
            updatedSelectedFiles.push({ id: result.data.id, name: file.name });
          }
        } catch (error) {
          console.error("Error uploading file:", error);
          setLoading(false);

          return;
        }
      }

      setEducationalDoc(updatedSelectedFiles);
      setLoading(false);
    } else {
      console.log("Please select at least one file.");
    }
  };

  const handleFileDelete = (index) => {
    const updatedEducationalDoc = [...educationalDoc];
    updatedEducationalDoc.splice(index, 1);
    setEducationalDoc(updatedEducationalDoc);
  };

  const handleFileInputChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setEditedData({ ...editedData, cnic_front: file.name });
      setCnicFront(file);
    } else {
      setEditedData({ ...editedData, cnic_back: null });
    }
  };

  const handleFileCnicBackChange = async (e) => {
    const file = e.target.files[0];
    if (file) {
      setEditedData({ ...editedData, cnic_back: file.name });
      setCnicBack(file);
    } else {
      setEditedData({ ...editedData, cnic_back: null });
    }
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  const handlefingerPrintPage = () => {
    setFringerprintpage(!fingerprintpage);
  };

  const getCurrentDate = () => {
    const today = new Date();
    const month = (today.getMonth() + 1).toString().padStart(2, "0");
    const day = today.getDate().toString().padStart(2, "0");
    return `${today.getFullYear()}-${month}-${day}`;
  };

  const calculateAge = (dateOfBirth) => {
    const today = new Date();
    const birthDate = new Date(dateOfBirth);
    let age = today.getFullYear() - birthDate.getFullYear();
    const month = today.getMonth() - birthDate.getMonth();
    if (month < 0 || (month === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age.toString();
  };

  const handleDateChange = (e) => {
    const dateOfBirth = e.target.value;
    const age = calculateAge(dateOfBirth);
    setEditedData({
      ...editedData,
      age: age,
      date_of_birth: dateOfBirth,
    });
  };

  const RenderPopup = ({ setShowModal }) => {
    return (
      <div className="fixed inset-0 z-[100] flex justify-center ">
        {/* backdrop */}
        <div
          className="absolute inset-0 bg-black/50"
          onClick={() => setShowModal(false)}
        ></div>

        {/* modal wrapper */}
        <div className="flex items-center justify-center overflow-y-auto w-full min-h-screen py-8 md:py-16 px-[16px] sm:px-4">
          <div className="relative z-[200] w-full max-w-4xl my-auto">
            <div className="bg-[#FCFBF7] rounded-3xl shadow-xl">
              {/* Close button */}
              <button
                className="absolute w-max top-4 right-4 text-gray-700 bg-primary-green/10 p-1 rounded-full cursor-pointer text-black shadow-none                     hover:text-gray-700 text-2xl"
                onClick={() => setShowModal(false)}
              >
                <IoMdClose />
              </button>

              {/* Header */}
              <div className="sm:mx-6 mc-[16px] pt-6 pb-4 border-b border-[#444444]">
                <h2 className="text-3xl font-bold text-gray-800">
                  Member Registration
                </h2>
              </div>
              <div className="field_Container">
                {step === 1 && (
                  <>
                    <form onSubmit={handleNext}>
                      <div className="group-fields">
                        <div className="field-container">
                          <h6 className="field-txt">First name</h6>
                          <input
                            type="text"
                            id="First name"
                            name="First name"
                            placeholder="First Name"
                            className="formField"
                            value={editedData.first_name}
                            onChange={(e) =>
                              setEditedData({
                                ...editedData,
                                first_name: e.target.value,
                              })
                            }
                            required
                          />
                        </div>
                        <div className="field-container">
                          <h6 className="field-txt">Last name</h6>
                          <input
                            type="text"
                            id="Last Name"
                            name="Last Name"
                            placeholder="Last Name"
                            className="formField"
                            value={editedData.last_name}
                            onChange={(e) =>
                              setEditedData({
                                ...editedData,
                                last_name: e.target.value,
                              })
                            }
                            required
                          />
                        </div>
                      </div>

                      <div className="group-fields">
                        <div className="field-container">
                          <h6 className="field-txt">Date of Birth</h6>
                          <input
                            type={type}
                            id="date"
                            name="DOB"
                            placeholder="Date of Birth"
                            onFocus={(event) => {
                              event.target.type = "date";
                            }}
                            className="formField"
                            onClick={(e) => setType("date")}
                            value={editedData.date_of_birth}
                            onChange={handleDateChange}
                            max={getCurrentDate()}
                            required
                          />
                        </div>
                        <div className="field-container">
                          <h6 className="field-txt">CNIC</h6>
                          <input
                            type="text"
                            id="CNIC"
                            name="CNIC"
                            placeholder="CNIC"
                            className="formField"
                            value={editedData.cnic_number}
                            onChange={(e) => {
                              const inputValue = e.target.value
                                .replace(/\D/g, "")
                                .slice(0, 14);
                              setEditedData({
                                ...editedData,
                                cnic_number: inputValue,
                              });
                            }}
                            pattern="\d*"
                            maxLength="14"
                            required
                          />
                        </div>
                      </div>

                      <div className="group-fields">
                        <div className="field-container">
                          <h6 className="field-txt">Age</h6>
                          <input
                            type="number"
                            id="Age"
                            name="Age"
                            placeholder="Age"
                            className="formField"
                            value={editedData.age}
                            onChange={(e) => {
                              const inputValue = e.target.value.slice(0, 3);
                              setEditedData({ ...editedData, age: inputValue });
                            }}
                            maxLength="3"
                            required
                            disabled
                          />
                        </div>
                        <div className="field-container">
                          <h6 className="field-txt">Education</h6>
                          <select
                            type="text"
                            id="Education"
                            name="Education"
                            placeholder="Education"
                            className="formField custom-select"
                            value={editedData?.education_or_qualification}
                            onChange={(e) =>
                              setEditedData({
                                ...editedData,
                                education_or_qualification: e.target.value,
                              })
                            }
                            required
                          >
                            <option>none</option>
                            <option>high_school</option>
                            <option>college</option>
                            <option>university</option>
                          </select>
                        </div>
                      </div>

                      <div className="group-fields">
                        <div className="field-container">
                          <h6 className="field-txt">Education status choice</h6>
                          <select
                            type="text"
                            id="Education status choice"
                            name="Education status choice"
                            placeholder="Education status choice"
                            className="formField custom-select"
                            value={editedData.education_status}
                            onChange={(e) =>
                              setEditedData({
                                ...editedData,
                                education_status: e.target.value,
                              })
                            }
                            required
                          >
                            <option>on_hold</option>
                            <option>completed</option>
                            <option>quitted</option>
                            <option>ongoing</option>
                          </select>
                        </div>
                        <div className="field-container">
                          <h6 className="field-txt">
                            Education status statement
                          </h6>
                          <input
                            type="text"
                            id="Education status statement"
                            name="Education status statement"
                            placeholder="Education status statement"
                            className="formField"
                            value={editedData.education_status_statement}
                            onChange={(e) =>
                              setEditedData({
                                ...editedData,
                                education_status_statement: e.target.value,
                              })
                            }
                            required
                          />
                        </div>
                      </div>

                      <div className="group-fields">
                        <div className="field-container">
                          <h6 className="field-txt">Willing to Study</h6>
                          <select
                            type="text"
                            id="Willing to Study"
                            name="Willing to Study"
                            placeholder="Willing to Study"
                            className="formField custom-select"
                            value={editedData.willing_to_study}
                            onChange={(e) =>
                              setEditedData({
                                ...editedData,
                                willing_to_study: e.target.value,
                              })
                            }
                            required
                          >
                            <option value={true}>Yes</option>
                            <option value={false}>No</option>
                          </select>
                        </div>
                        <div className="field-container">
                          <h6 className="field-txt">Job</h6>
                          <input
                            type="text"
                            id="Job"
                            name="Job"
                            placeholder="Job"
                            className="formField"
                            value={editedData.job}
                            onChange={(e) =>
                              setEditedData({
                                ...editedData,
                                job: e.target.value,
                              })
                            }
                            required
                          />
                        </div>
                      </div>
                      <div className="next_btn">
                        <button className="primary-button w-max">Next</button>
                      </div>
                    </form>
                  </>
                )}
                {step === 2 && (
                  <>
                    <form onSubmit={handleNext} encType="multipart/form-data">
                      <div className="group-fields">
                        <div className="field-container">
                          <h6 className="field-txt">Monthly income</h6>
                          <input
                            type="number"
                            id="Monthly income"
                            name="Monthly income"
                            placeholder="Monthly income"
                            className="formField"
                            value={editedData.monthly_income}
                            onChange={(e) =>
                              setEditedData({
                                ...editedData,
                                monthly_income: e.target.value,
                              })
                            }
                            required
                          />
                        </div>
                        <div className="field-container">
                          <h6 className="field-txt">Permanent medication</h6>
                          <select
                            type="text"
                            id="Permanent medication"
                            name="Permanent medication"
                            placeholder="Permanent medication"
                            className="formField custom-select"
                            value={editedData.permanent_medication}
                            onChange={(e) => {
                              const value = e.target.value;
                              setEditedData({
                                ...editedData,
                                permanent_medication: value,
                              });
                              setDisableField(value === "true");
                            }}
                            required
                          >
                            <option value={true}>Yes</option>
                            <option value={false}>No</option>
                          </select>
                        </div>
                      </div>

                      <div className="group-fields">
                        <div className="field-container">
                          <h6 className="field-txt">Medical condition</h6>
                          <input
                            type="text"
                            id="Medical condition"
                            name="Medical condition"
                            placeholder="Medical condition"
                            className="formField"
                            value={editedData.medical_condition}
                            onChange={(e) =>
                              setEditedData({
                                ...editedData,
                                medical_condition: e.target.value,
                              })
                            }
                            disabled={
                              editedData.permanent_medication === "false"
                            }
                            required
                          />
                        </div>
                        <div className="field-container">
                          <h6 className="field-txt">Medication description</h6>
                          <input
                            type="text"
                            id="Medication description"
                            name="Medication description"
                            placeholder="Medication description"
                            className="formField"
                            value={editedData.permanent_medication_description}
                            onChange={(e) =>
                              setEditedData({
                                ...editedData,
                                permanent_medication_description:
                                  e.target.value,
                              })
                            }
                            required
                            disabled={
                              editedData.permanent_medication === "false"
                            }
                          />
                        </div>
                      </div>

                      <div className="group-fields">
                        <div className="field-container">
                          <h6 className="field-txt">Gender</h6>
                          <select
                            type="text"
                            id="Gender"
                            name="Gender"
                            placeholder="Gender"
                            className="formField custom-select"
                            value={editedData.gender}
                            onChange={(e) =>
                              setEditedData({
                                ...editedData,
                                gender: e.target.value,
                              })
                            }
                            required
                          >
                            <option>Male</option>
                            <option>Female</option>
                          </select>
                        </div>
                        <div className="field-container">
                          <h6 className="field-txt">Skills</h6>
                          <input
                            type="text"
                            id="Skills"
                            name="Skills"
                            placeholder="Skills"
                            className="formField "
                            value={editedData.skills}
                            onChange={(e) =>
                              setEditedData({
                                ...editedData,
                                skills: e.target.value,
                              })
                            }
                            required
                          />
                        </div>
                      </div>

                      <div className="group-fields">
                        <div className="field-container">
                          <h6 className="field-txt">Martial status</h6>
                          <select
                            type="text"
                            id="Martial status"
                            name="Martial status"
                            placeholder="Martial status"
                            className="formField custom-select"
                            value={editedData.marital_status}
                            onChange={(e) =>
                              setEditedData({
                                ...editedData,
                                marital_status: e.target.value,
                              })
                            }
                            required
                          >
                            <option>single</option>
                            <option>married</option>
                            <option>committed</option>
                            <option>divorced</option>
                            <option>widow</option>
                          </select>
                        </div>
                        <div className="field-container">
                          <h6 className="field-txt">Number of childrens</h6>
                          <input
                            type="number"
                            id="Number of childrens"
                            name="Number of childrens"
                            placeholder="Number of childrens"
                            className="formField"
                            value={editedData.num_of_childrens}
                            onChange={(e) => {
                              const inputValue = e.target.value.slice(0, 3);
                              setEditedData({
                                ...editedData,
                                num_of_childrens: inputValue,
                              });
                            }}
                            maxLength="3"
                            required
                            disabled={
                              editedData.marital_status === "single" ||
                              editedData.marital_status === "committed"
                            }
                          />
                        </div>
                      </div>

                      <div className="btn_conatiner">
                        <button
                          onClick={handleBack}
                          className="Registration_Backbtn"
                        >
                          Back
                        </button>
                        <button className="primary-button w-max">Next</button>
                      </div>
                    </form>
                  </>
                )}

                {step === 3 && (
                  <>
                    {loading && (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          height: "100vh",
                        }}
                      >
                        <Lottie
                          loop={true}
                          animationData={Loader}
                          style={{ width: "200px" }}
                          className="auth-sidebar-video"
                        />
                      </div>
                    )}
                    {!loading && (
                      <form onSubmit={handleUpdate}>
                        {fingerprintpage ? (
                          <FingerPrintPage
                            handlefingerPrintPage={handlefingerPrintPage}
                          />
                        ) : (
                          <>
                            <div className="group-fields">
                              <div className="field-container">
                                <h6 className="field-txt">
                                  Educational attachment
                                </h6>
                                <div className="upload-field">
                                  <input
                                    type="file"
                                    id="Educational attachment"
                                    name="Educational attachment"
                                    onChange={handleEducationalChange}
                                    accept=".pdf"
                                    style={{ display: "none" }}
                                    multiple
                                  />
                                  <input
                                    type="text"
                                    id="Educational attachment-text"
                                    name="Educational attachment-text"
                                    placeholder="Upload Educational Doc"
                                    onClick={() =>
                                      document
                                        .getElementById(
                                          "Educational attachment"
                                        )
                                        .click()
                                    }
                                    className="formField with-icon"
                                    value={
                                      editedData?.education_documents?.length >
                                      0
                                        ? editedData.education_documents[0]
                                            ?.file
                                        : "" || educationalDoc[0]?.name
                                    }
                                    readOnly
                                    required
                                  />
                                  <div className="selected-files ms-2">
                                    {educationalDoc.map((file, index) => (
                                      <div
                                        key={index}
                                        className="selected-file"
                                      >
                                        <span>{file.name}</span>
                                        <span
                                          className="delete-icon"
                                          onClick={() =>
                                            handleFileDelete(index)
                                          }
                                        >
                                          <img
                                            src={require("../assets/delete.png")}
                                            alt="delete"
                                            width="15px"
                                            height="15px"
                                          />
                                        </span>
                                      </div>
                                    ))}
                                  </div>
                                </div>
                              </div>

                              <div className="field-container">
                                <h6 className="field-txt">
                                  Work Experience attachment
                                </h6>
                                <div className="upload-field">
                                  <input
                                    type="file"
                                    id="Work Experience"
                                    name="Work Experience"
                                    onChange={handleWorkChange}
                                    accept=".pdf"
                                    style={{ display: "none" }}
                                    multiple
                                  />
                                  <input
                                    type="text"
                                    id="Work Experience-text"
                                    name="Work Experience-text"
                                    placeholder="Upload Work Experience Doc"
                                    onClick={() =>
                                      document
                                        .getElementById("Work Experience")
                                        .click()
                                    }
                                    className="formField with-icon"
                                    value={
                                      editedData?.work_experience_documents
                                        ?.length > 0
                                        ? editedData
                                            .work_experience_documents[0]?.file
                                        : "" || workExperience[0]?.name
                                    }
                                    readOnly
                                    required
                                  />
                                  <div className="selected-files ms-2">
                                    {workExperience?.map((file, index) => (
                                      <div
                                        key={index}
                                        className="selected-file"
                                      >
                                        <span>{file.name}</span>
                                        <span
                                          className="delete-icon"
                                          onClick={() =>
                                            handleworkFileDelete(index)
                                          }
                                        >
                                          <img
                                            src={require("../assets/delete.png")}
                                            alt="delete"
                                            width="15px"
                                            height="15px"
                                          />
                                        </span>
                                      </div>
                                    ))}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="group-fields">
                              <div className="field-container">
                                <h6 className="field-txt">Cnic-front</h6>
                                <div className="upload-field">
                                  <input
                                    type="file"
                                    id="cnic-front"
                                    name="cnic-front"
                                    onChange={handleFileInputChange}
                                    accept=".jpg, .jpeg, .png"
                                    style={{ display: "none" }}
                                  />
                                  <input
                                    type="text"
                                    id="cnic-front-text"
                                    name="cnicfront-text"
                                    placeholder="Upload CNIC Front"
                                    onClick={() =>
                                      document
                                        .getElementById("cnic-front")
                                        .click()
                                    }
                                    className="formField with-icon"
                                    value={editedData.cnic_front}
                                    readOnly
                                    required
                                  />
                                </div>
                              </div>
                              <div className="field-container">
                                <h6 className="field-txt">Cnic-back</h6>
                                <div className="upload-field">
                                  <input
                                    type="file"
                                    id="cnic-back"
                                    name="cnic-back"
                                    onChange={handleFileCnicBackChange}
                                    accept=".jpg, .jpeg, .png"
                                    style={{ display: "none" }}
                                  />
                                  <input
                                    type="text"
                                    id="cnic-back-text"
                                    name="cnicback-text"
                                    placeholder="Upload CNIC Back"
                                    onClick={() =>
                                      document
                                        .getElementById("cnic-back")
                                        .click()
                                    }
                                    className="formField with-icon"
                                    value={editedData.cnic_back}
                                    readOnly
                                    required
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="group-fields">
                              <div className="field-container">
                                <h6 className="field-txt">Select Family</h6>
                                <input
                                  type="text"
                                  id="family"
                                  name="family"
                                  placeholder="family"
                                  className="formField"
                                  value={familyData?.name}
                                  required
                                  disabled
                                />
                              </div>
                            </div>
                            <div className="group-fields">
                              <div className="field-container">
                                <h6 className="field-txt">
                                  Add Family member fingerprints
                                </h6>
                                <button
                                  className="Register_btn"
                                  onClick={handlefingerPrintPage}
                                >
                                  Add
                                </button>
                              </div>
                            </div>
                          </>
                        )}

                        <div className="btn_conatiner">
                          {!fingerprintpage && (
                            <button
                              onClick={handleBack}
                              className="Registration_Backbtn"
                            >
                              Back
                            </button>
                          )}
                          <button className="primary-button w-max" type="submit">
                            Update
                          </button>
                        </div>
                      </form>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <Header parent={"family"} />
      <div className="mt-20" style={{ backgroundColor: "#ffffff", minHeight: "100vh" }}>
        {/* Back Button */}
        <button
          className="p-1 sm:ml-6 ml-[14px] w-max rounded-circle d-flex align-items-center justify-content-center mb-4 text-white bg-primary-green"
          onClick={handleGoBack}
        >
          <FaChevronLeft size={24}/>
        </button>
        {isLoading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100vh",
            }}
          >
            <Lottie
              loop={true}
              animationData={Loader}
              style={{ width: "200px" }}
              className="auth-sidebar-video"
            />
          </div>
        ) : (
          <div className="max-w-screen-xl mx-auto md:px-6 px-[16px]">
            {/* Profile Header Section */}
            <div className="profile-header-section flex justify-between md:items-end items-start gap-4">
              <div className="info w-full gap-2">
                <div className="profile-avatar-container">
                  <div className="profile-avatar">
                    <span className="avatar-text">
                      {data?.first_name?.charAt(0)}
                      {data?.last_name?.charAt(0)}
                    </span>
                  </div>
                </div>
                <div className="w-full flex flex-col items-start">
                  <div className="flex justify-between items-center  gap-2 w-full">
                    <h1 className="profile-name">
                      {data?.first_name} {data?.last_name}
                    </h1>
                    <span
                      className="md:hidden block primary-button"
                      onClick={() => handleEditClick(data?.family?.id)}
                    >
                      Edit
                    </span>
                  </div>

                  <div className="profile-badges">
                    <span className="badge badge-gender">
                      Gender: {data?.gender}
                    </span>
                    <span className="badge badge-status">
                      {data?.marital_status}
                    </span>
                    <span className="badge badge-gender">Age: {data?.age}</span>
                    <span className="badge badge-gender">
                      D.O.B: {data?.date_of_birth}
                    </span>
                  </div>
                </div>
              </div>

              <span
                className="md:block hidden primary-button"
                onClick={() => handleEditClick(data?.family?.id)}
              >
                Edit
              </span>
            </div>

            {/* Main Content Grid */}
            <div className="content-grid">
              {/* Left Column - Family Information */}
              <div className="info-section ">
                <h2 className="section-title md:w-[33%] w-2/5">
                  Family Information
                </h2>
                <div className="w-3/5 md:w-[66%]">
                  <div className="info-row">
                    <span className="info-row-label">Family Head</span>
                    <span className="info-row-value">{data?.family?.name}</span>
                  </div>

                  <div className="info-row">
                    <span className="info-row-label">No. of Brothers</span>
                    <span className="info-row-value">
                      {data?.family?.num_of_brothers || 0}
                    </span>
                  </div>

                  <div className="info-row">
                    <span className="info-row-label">No. of Sisters</span>
                    <span className="info-row-value">
                      {data?.family?.num_of_sisters || 0}
                    </span>
                  </div>

                  <div className="info-row">
                    <span className="info-row-label">Number of Children</span>
                    <span className="info-row-value">
                      {data?.num_of_childrens}
                    </span>
                  </div>

                  <div className="info-row">
                    <span className="info-row-label">Skills</span>
                    <span className="info-row-value">{data?.skills}</span>
                  </div>
                </div>
              </div>

              {/* Right Column - Parents Information */}
              <div className="info-section">
                <h2 className="section-title md:w-1/3 w-2/5">
                  Parents Information
                </h2>
                <div className="w-3/5 md:w-2/3">
                  <div className="info-row highlighted">
                    <span className="info-row-label">Father Name</span>
                    <span className="info-row-value">
                      {data?.family?.father_name || "N/A"}
                    </span>
                  </div>

                  <div className="info-row">
                    <span className="info-row-label">Mother Name</span>
                    <span className="info-row-value">
                      {data?.family?.mother_name || "N/A"}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            {/* Educational & Occupational Information */}
            <div className="info-section full-width">
              <h2 className="section-title w-2/5 md:w-1/3">
                Educational & Occupational Information
              </h2>
              <div className="w-3/5 md:w-2/3">
                <div className="info-row">
                  <span className="info-row-label">Job</span>
                  <span className="info-row-value">{data?.job}</span>
                </div>

                <div className="info-row">
                  <span className="info-row-label">Monthly Income</span>
                  <span className="info-row-value">{data?.monthly_income}</span>
                </div>

                <div className="info-row">
                  <span className="info-row-label">Education</span>
                  <span className="info-row-value">
                    {data?.education_or_qualification}
                  </span>
                </div>

                <div className="info-row">
                  <span className="info-row-label">Education Status</span>
                  <span className="info-row-value">
                    {data?.education_status}
                  </span>
                </div>

                <div className="info-row">
                  <span className="info-row-label">Willing to Study</span>
                  <span className="info-row-value">
                    {data?.willing_to_study ? "Yes" : "No"}
                  </span>
                </div>

                <div className="info-row">
                  <span className="info-row-label">Medical Condition</span>
                  <span className="info-row-value">
                    {data?.medical_condition || "None"}
                  </span>
                </div>
              </div>
            </div>

            {/* Identification Section */}
            <div className="info-section full-width">
              <h2 className="section-title w-2/5 md:w-1/3">Identification</h2>
              <div className="w-3/5 md:w-2/3">
                <div className="info-row">
                  <span className="info-row-label">CNIC</span>
                  <span className="info-row-value">
                    {data?.cnic_number || "N/A"}
                  </span>
                </div>

                <div className="info-row">
                  <span className="info-row-label">Description</span>
                  <span className="info-row-value">
                    {data?.education_status_statement}
                  </span>
                </div>
              </div>
            </div>

            {/* Document Attachments */}
            <div className=" full-width md:mt-6 mt-4">
              <h2 className="section-title">Document Attachments</h2>

              <div className="documents-grid grid sm:grid-cols-2 grid-cols-1 gap-6">
                <DocumentCard title="CNIC Front" file={data?.cnic_front} />
                <DocumentCard title="CNIC Back" file={data?.cnic_back} />
                <DocumentCard
                  title="Work Experience"
                  file={data?.work_experience_documents?.[0]?.file}
                />
                <DocumentCard
                  title="Education Document"
                  file={data?.education_documents?.[0]?.file}
                />
              </div>
            </div>
          </div>
        )}
      </div>
      {isEditing && <RenderPopup setShowModal={setIsEditing} />}
    </>
  );
};
